import { LockIcon } from "@components/Icons/Lock"
import { UnlockIcon } from "@components/Icons/Unlock"
import { SetState } from "@custom-types/utils"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { shortcuts } from "@features/keymap/shortcuts"
import { useKeymap } from "@features/keymap/useKeymap"
import { ControlButton } from "@xyflow/react"

export const GraphInteractionToggleButton = (props: {
  isOn: boolean
  onLockGraph: SetState<boolean>
}) => {
  const keymap = useKeymap()

  const handleToggle = () => props.onLockGraph((state) => !state)
  const handleLock = () => props.onLockGraph(true)
  const handleUnlock = () => props.onLockGraph(false)

  return (
    <>
      <KeyBinding bind={shortcuts["toggle-lock"]} onKeyDown={handleToggle} />
      <KeyBinding bind={shortcuts["pan-graph"]} onKeyDown={handleLock} onKeyUp={handleUnlock} />
      <ControlButton
        className="react-flow__controls-interactive"
        data-testid="graph-controls-toggle-interactivity-btn"
        onClick={handleToggle}
        title={keymap.getKeymaps().byId.get("toggle-lock")?.desc}
        aria-label="toggle interactivity"
      >
        {props.isOn ? <UnlockIcon /> : <LockIcon />}
      </ControlButton>
    </>
  )
}
